module.exports = __webpack_public_path__ + "static/movies-zoom-8b36fb4a3e3977d008e1d732fee7f909.jpg";